import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../../common/actions';

class AddLink extends Component {
  constructor(props) {
    super(props);
    this.handleAddClick = this.handleAddClick.bind(this);
  }

  handleAddClick() {
    const {provider, transport, orderType} = this.props;

    if (!provider || !transport || !orderType) {
      this.props.addMessageBoxError(
        'Por favor seleccione el proveedor, el transporte y el tipo de repuesto antes de continuar.'
      );
      return;
    }

    this.props.addElementToProviderManualOrder();
  }

  render() {
    return (
      <a onClick={this.handleAddClick}><strong>+ AGREGAR REGISTRO</strong></a>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'provider': state.providerManualOrder.provider,
    'transport': state.providerManualOrder.transport,
    'orderType': state.providerManualOrder.orderType,
  };
};

const {
  addMessageBoxError,
  addElementToProviderManualOrder,
} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxError,
  addElementToProviderManualOrder,
})(AddLink);
